import {observer} from "mobx-react";
import {Component} from "preact";
import {resources} from "../resources";
import {Dialog, DialogAlignment, DialogContent, DialogTitle} from "./controls/Dialog";
import {Spinner} from "./controls/Spinner";
import style from "./UpdateDialog.module.css";

export const UpdateDialog = observer(
	class UpdateDialog extends Component<{ open: boolean }> {
		render() {
			return (
				<Dialog open={this.props.open} alignment={DialogAlignment.CenterAutoWidth}>
					<DialogContent>
						<DialogTitle>{resources.strings.UpdateTitle}</DialogTitle>
						<p>{resources.strings.UpdatePendingMessage}</p>
						<div class={style.spinner}>
							<Spinner />
						</div>
					</DialogContent>
				</Dialog>
			);
		}
	},
);
